module.exports = __webpack_public_path__ + "img/jiuzhang-back-one@3x.e65d754c.jpg";